<template>
  <div class="bgray-200 text-left">
    <b-navbar toggleable="sm" type="dark" class="bgray-900 header-nav">
        <b-navbar-brand><router-link to="/"><b-img class="header-logo" src="/images/QESG_Assessment_basic.svg"></b-img></router-link></b-navbar-brand>
    </b-navbar>

    <b-container class="py-5">
        <h2 class="pt-5 mb-4 fw-600"> {{ $t(mode) }} </h2>
        
        <b-card v-if="mode=='이용약관'" class="mb-5">
            <terms-of-use></terms-of-use>
        </b-card>
        <b-card v-else-if="mode=='개인정보 처리방침'" class="mb-5"> 
            <privacy-policy></privacy-policy>
        </b-card>    
    </b-container>

    <div class="w-100 py-2 bgray-700 gray-400 f-90">
        <span class="pl-5"> Copyright <fa icon="copyright" class="mr-2"></fa>2021 </span> <span class="pr-2">QuantifiedESG, Inc.</span> (주)퀀티파이드이에스지
    </div>
  </div>
</template>

<script>
import TermsOfUse from '@shared_components/utils/service_policies/TermsOfUse'
import PrivacyPolicy from '@shared_components/utils/service_policies/PrivacyPolicy'

export default {
    data() {
        return {
           
        }
    },
    computed:{
        mode(){
            return this.$store.state.service_policy_mode
        }
    },
    methods:{

    },
    components: {
        TermsOfUse,
        PrivacyPolicy
    }

}
</script>

<style>

</style>